$(document).ready(function() {
  if ($('.toggle_list li a').length) {
    $('.toggle_list li a').each(function() {
      if ($(this).hasClass('active')) {
        $('.toggle_list').css('display', 'block');
        return false;
      }
    });
  }

  var readmore = new Readmore('.readmore', {
    collapsedHeight: detectMobile() ? 120 : 130,
    embedCSS: false,
    afterToggle: function(trigger, element, expanded) {
      if (!expanded) { // The "Close" link was clicked
        window.scrollTo({
          top: element.offsetTop,
          behavior: 'smooth'
        })
      }
    },
    moreLink: '<div class="container" style="padding:0;margin-bottom:15px;"><a href="#">Read more</a></div>',
    lessLink: '<div class="container" style="padding:0;margin-bottom:15px;"><a href="#">Read less</a></div>'
  });

  $(".collapse-tabs").each(function () {
    if ($(this).parent().find('.tabs-content').length == 0) {
      $(this).hide()
    }
  })
  $(".collapse-tabs").click(function () {
    $(this).parent().find('.tabs-content').toggle();
    if ($(this).find('.expend').hasClass('hidden')) {
      $(this).find('.expend').removeClass('hidden')
      $(this).find('.collapse').addClass('hidden')
    } else  {
      $(this).find('.collapse').removeClass('hidden')
      $(this).find('.expend').addClass('hidden')
    }
  })

  $(".default-filter-wrapper .filter-button-wrapper").click(function () {
    $('#faceted-filters .filters').toggle()
    if ($(this).find('.expend').hasClass('hidden')) {
      $(this).find('.expend').removeClass('hidden')
      $(this).find('.collapse').addClass('hidden')
    } else  {
      $(this).find('.collapse').removeClass('hidden')
      $(this).find('.expend').addClass('hidden')
    }
  })

  $('.description .tabs li a').click(function () {
    $(this).closest('.description').find('.collapse').removeClass('hidden')
    $(this).closest('.description').find('.expend').addClass('hidden')
    $(this).closest('.description').find('.tabs-content').show()
  })
  if ($('.sub-description ').length > 0) {
    if ($(".description .tabs-content").length > 1) {
      const el = $('.description .tabs-content > #tab1')
      el.append('<br>')
      el.append('<br>')
      el.append($('.sub-description').html())
    } else {
      $('.sub-description').removeClass('hidden')
    }
  }

  $('.product-selectore a').click(function () {
    const id = $(this).data('id')
    const productId = $(this).data('productid')
    const planId = $(this).data('planid')
    let form = $('.product__container form.shopify-product-form')
    if (form.length > 0) {
      form.data('productid', productId);
      form.find('input[name="id"]').val(id)
      form.find('input[name="product-id"]').val(productId)
      form.find('select[name="selling_plan"] option').attr('value', planId)
    }
  })
  triggerSettingPlan()

  function triggerSettingPlan() {
    if (  $('.product-selectore a').length  > 0) {
      let intervalTriggerData = setInterval(function () {
        let optionValue = $('.product__container form.shopify-product-form select[name="selling_plan"] option');
        if (optionValue.length > 0) {
          $('.product-selectore a.active').trigger('click')
          clearInterval(intervalTriggerData);
        }
      } ,1000)
    }
  }
});

function detectMobile() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}
$('.filters .filter-group .filter-group-title').click(function (event) {
  const filterGroup = $(this).closest('.filter-group')
  filterGroup.find('.list-filter-value').toggleClass('hidden')
  filterGroup.find('.toggle-icon div').toggleClass('hidden')
  console.log('trigger')
})
$('#faceted-filters input').change(function () {
  const form = $('#faceted-filters')
  const checkedInputs = form.find('input[type="checkbox"]:checked');
  form.submit()
})
$('#faceted-filters').submit(function (event) {
  event.preventDefault();
  // Get the form element
  const form = event.target;
  const checkedInputs = form.querySelectorAll('input[type="checkbox"]:checked');
  checkedInputs.forEach(input => {
    if (input.name.includes('between')) {
      // Split the value into lower (gte) and upper (lte) thresholds
      const [gte, lte] = input.value.split('-').map(Number);

      if (!isNaN(gte) && !isNaN(lte)) {
        // Create separate hidden inputs for gte and lte
        const gteInput = document.createElement('input');
        gteInput.type = 'hidden';
        gteInput.name = input.name.replace('between', 'gte');
        gteInput.value = gte;

        const lteInput = document.createElement('input');
        lteInput.type = 'hidden';
        lteInput.name = input.name.replace('between', 'lte');
        lteInput.value = lte;

        // Append the new inputs to the form
        form.appendChild(gteInput);
        form.appendChild(lteInput);
      } else {
        console.error(`Invalid range value in ${input.name}: ${input.value}`);
        alert('Please enter a valid range in the format "min-max".');
      }
    }
  });
  form.submit();

})